import '../list/gb-list.tag.html';
import './gb-refinement-crumb.tag.html';
import { Breadcrumbs } from './gb-breadcrumbs';
riot.tag2('gb-breadcrumbs', '<yield> <div class="gb-breadcrumbs {_style}"> <div class="gb-query-crumb" if="{!_config.hideQuery && originalQuery}">{originalQuery}</div> <gb-list items="{selected}" if="{!_config.hideRefinements}" scope="gb-breadcrumbs"> <gb-list class="gb-navigation-crumb" items="{item.refinements}" inline> <gb-refinement-crumb nav="{parent.item}" ref="{item}"></gb-refinement-crumb> </gb-list> </gb-list> </div> </yield>', 'gb-breadcrumbs .gb-stylish.gb-breadcrumbs,[riot-tag="gb-breadcrumbs"] .gb-stylish.gb-breadcrumbs,[data-is="gb-breadcrumbs"] .gb-stylish.gb-breadcrumbs{ display: flex; justify-content: flex-start; align-items: baseline; }', '', function(opts) {
    this._mixin(Breadcrumbs);
});



/** WEBPACK FOOTER **
 ** ./src/tags/breadcrumbs/gb-breadcrumbs.tag.html
 **/